export default {
  CHANGE_LOADING(state, payload) {
    state.loading = payload;
  },
};
